import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Award, FileText, ClipboardCheck, BookOpen, Home } from 'lucide-react';
import { useTranslation } from '../translations';

/**
 * CertificationNav - Navegação do Sistema de Certificação
 * 
 * Links rápidos para todas as páginas do sistema de avaliação
 */

const CertificationNav = () => {
  const location = useLocation();
  const { t } = useTranslation();
  
  const links = [
    {
      path: '/',
      label: t('navHome'),
      icon: Home,
      color: 'gray'
    },
    {
      path: '/certification',
      label: 'LGPD',
      icon: Award,
      color: 'green',
      description: 'Consentimento LGPD'
    },
    {
      path: '/evaluation-form',
      label: t('navEvaluation'),
      icon: ClipboardCheck,
      color: 'blue',
      description: t('technicalCriteria')
    },
    {
      path: '/technical-references',
      label: t('navDocuments'),
      icon: BookOpen,
      color: 'amber',
      description: t('officialDocs')
    }
  ];

  const colorClasses = {
    gray: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
    green: 'bg-green-100 text-green-700 hover:bg-green-200',
    blue: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
    amber: 'bg-amber-100 text-amber-700 hover:bg-amber-200'
  };

  const activeClasses = {
    gray: 'bg-gray-600 text-white',
    green: 'bg-green-600 text-white',
    blue: 'bg-blue-600 text-white',
    amber: 'bg-amber-600 text-white'
  };

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* Logo/Título */}
          <div className="flex items-center gap-2">
            <Award className="w-6 h-6 text-green-600" />
            <span className="font-bold text-gray-800 hidden sm:inline">
              HeveaTalent
            </span>
          </div>
          
          {/* Links de Navegação */}
          <nav className="flex items-center gap-2">
            {links.map(link => {
              const Icon = link.icon;
              const isActive = location.pathname === link.path;
              
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                    isActive ? activeClasses[link.color] : colorClasses[link.color]
                  }`}
                  title={link.description}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden md:inline">{link.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default CertificationNav;
